import { useQuery, UseQueryResult } from 'react-query';
import fetchUserInfo from '../adapters/services/userInfoService';
import { UserDetailsResponse } from '../adapters/types';

const useUserDetails = (
  token: string,
  remote_user: string,
): UseQueryResult<UserDetailsResponse> => useQuery(
  'user/details/with-account-type/I',
  () => fetchUserInfo(`Bearer ${token}`, remote_user),
  {
    enabled: !!token,
  },
);

export default useUserDetails;
